@if (!internetAvailable && !isBlockedApp) {
  <ion-row class="ion-no-padding ion-padding-top ion-text-center">
    @if (featureNotAvailable === undefined) {
      <ion-col size="12">
        <ion-label
          class="ion-text-wrap"
          color="white"
          [innerHTML]="'COMMON.NO_INTERNET_CONNECTION' | translate"
        ></ion-label>
      </ion-col>
    } @else {
      <ion-col size="12">
        <ion-label class="ion-text-wrap" color="white" [innerHTML]="featureNotAvailable | translate"></ion-label>
      </ion-col>
    }
  </ion-row>
}

@if (isBlockedApp) {
  <ion-row class="ion-text-center">
    <ion-col size="12" class="ion-text-center ion-padding-horizontal ion-no-padding-bottom">
      <ion-label class="ion-text-wrap ion-text-uppercase" color="white" translate>COMMON.ALERT</ion-label>
    </ion-col>

    <ion-col size="12" class="ion-padding-horizontal">
      <ion-label class="ion-text-wrap" color="white" [innerHTML]="'COMMON.CONNECT_TO_INTERNET' | translate"></ion-label>
    </ion-col>
  </ion-row>
}
